import {
  AssessmentSettingsFragment,
  MarkingTool,
  RequirementsFragment,
} from "generated/graphql";

/**
 * Convert Assessment Settings back into editable Task requirements.
 */
export function fromAssessmentSettings(
  reqs: AssessmentSettingsFragment
): RequirementsFragment {
  const {
    id,
    dueDate,
    maxGrade,
    draftDueDate,
    wordLimit,
    timeLimit,
    weight,
    referencingStyle,
    countReferences,
    countFootnotes,
    anonymousMarking,
    assessmentType,
    examEndDate,
    examReadingTime,
    examStartDate,
    examTiming,
    examType,
    examWritingTime,
    lateSubmissionTimeLimit,
    allowGenerativeAi,
    markingToolPdf,
    restrictMarkingToolPdf,
  } = reqs;

  return {
    id,
    assessmentType,
    dueDate,
    returnDate: reqs.feedbackDate,

    draftDueDate,
    noDraft: !reqs.draftEnabled,

    maxGrade,
    anonymousMarking,
    gradingService: markingTooltoString(reqs.markingTool),

    sViewReports: reqs.tiiSViewReports,
    draftSViewReports: reqs.tiiDraftSViewReports,

    lateSubmissionTimeLimit,
    allowLateResubmission: reqs.lateResubmissionEnabled,

    weight,
    noWeight: reqs.weightEnabled === false || weight === null,

    wordLimit,
    noLimit: reqs.wordLimitEnabled === false || wordLimit === null,

    timeLimit,
    noTimeLimit: reqs.timeLimitEnabled === false || timeLimit === null,

    countReferences: countReferences ?? false,
    countFootnotes: countFootnotes ?? false,

    referencingStyle,
    noReferencing:
      reqs.referencingStyleEnabled == false ||
      referencingStyle === null ||
      referencingStyle === "",

    hasChanged: true,

    enableExamAutoSubmission: reqs.examAutoSubmissionDisabled === false,
    enableSubmissionPdf: reqs.submissionPdfDisabled === false,
    examEndDate,
    examReadingTime,
    noExamReadingTime:
      reqs.examReadingTimeDisabled === true || examReadingTime === null,
    examStartDate,
    examTiming,
    examType,
    examWritingTime,
    disableExamBacktrack: reqs.examBacktrackDisabled,

    examFeedbackDate: reqs.feedbackDate,
    noExamFeedbackDate:
      reqs.feedbackDateDisabled === true || reqs.feedbackDate === null,

    enableExamLdb: reqs.examLdbEnabled,
    enableExamAccessCode: reqs.examAccessCodeEnabled,

    restrictMarkingToolPdf,
    markingToolPdf,

    allowGenerativeAi,
    disableSpellCheck: reqs.spellCheckDisabled,
  };
}

function markingTooltoString(markingTool: MarkingTool | null) {
  switch (markingTool) {
    case MarkingTool.Turnitin:
      return "turnitin";
    case MarkingTool.Cadmusgrader:
      return "cadmusgrader";
    case MarkingTool.Moodlegrader:
      return "moodlegrader";
    case MarkingTool.Speedgrader:
      return "speedgrader";
    default:
      return "unknown";
  }
}
